import { TRANSLATIONS } from '../../constants';
import { Api, apiCall, nonProduction, saveDocument } from '../../services';
import { toggleLoading } from '../../store';
import { useAppDispatch, useAppSelector, useTranslate } from '../common';
import { showStatusMessage } from '@innomotics/innomotics-build-react-lib';

export const useDebugData = () => {
    const translate = useTranslate();
    const dispatch = useAppDispatch();
    const calculationResponse = useAppSelector(state => state.motor.calculationResponse);

    const handleExportPointsClick = () => {
        if (calculationResponse) {
            const { curveData, mesParameters } = calculationResponse;

            (async () => {
                dispatch(toggleLoading());

                await apiCall(
                    Api.getCurvePointsDocument({
                        mlfb: nonProduction ? mesParameters.motorData.mlfb : undefined,
                        curves: curveData
                    }),
                    async x => {
                        const { name, data, mimeType } = x.data;

                        saveDocument(name, data, mimeType);
                    },
                    async () => {
                        showStatusMessage({
                            message: translate(TRANSLATIONS.snackbar.error.documentGeneration.text),
                            showProgress: true,
                            type: 'error'
                        });
                    }
                );

                dispatch(toggleLoading());
            })();
        }
    };

    return {
        onExportPointsClick: handleExportPointsClick
    };
};
